import type { IconSvgObject } from './types';

const ReceiptCentIcon: IconSvgObject = [
  ["path", { d: "M9.5 2L12 3.5L14.5 2L17 3.5L20 2V22L17 20.5L14.5 22L12 20.5L9.5 22L7 20.5L4 22V2L7 3.5L9.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 9.35418C14.2671 8.52375 13.1947 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C13.1947 16 14.2671 15.4762 15 14.6458", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 7V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ReceiptCentIcon;
